import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useState } from 'react';
import { merge } from 'lodash-es';
import { zIndexScale } from '../../foundations/zIndex.constants';
import { useIsInBottomSheet } from '../../providers';
import { useDevice } from '../../providers/Device';
import { BottomSheet } from '../BottomSheet';
import { BaseTextField } from '../TextField/BaseTextField/BaseTextField';
import { MobileSelect, SelectOptionsBottomSheet } from './MobileSelect';
// WHY: see note on BaseTextField — forwardRef + MUI types collapses BiProps' discriminated union.
const SelectImpl = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { mobile, menuAsPopover } = props, restProps = _object_without_properties(props, [
        "mobile",
        "menuAsPopover"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    // eslint-disable-next-line no-restricted-syntax -- WHY: BottomSheet IS the declarative overlay the rule points at, and it takes `open` as a prop, so this seagull surface owns that state itself instead of deferring to showModal.
    const [isOpen, setIsOpen] = useState(false);
    const closeOptionsSheet = ()=>setIsOpen(false);
    if (!menuAsPopover && (isInBottomSheet || !(mobile === null || mobile === void 0 ? void 0 : mobile.renderAsCard) && isMobileDevice)) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, restProps), {
                    ref: ref,
                    select: true,
                    SelectProps: merge(restProps.SelectProps, {
                        open: false,
                        onOpen: ()=>setIsOpen(true)
                    })
                })),
                /*#__PURE__*/ _jsx(BottomSheet, {
                    open: isOpen,
                    onClose: closeOptionsSheet,
                    children: /*#__PURE__*/ _jsx(SelectOptionsBottomSheet, _object_spread_props(_object_spread({
                        saveOnSelect: true
                    }, restProps), {
                        onDone: closeOptionsSheet
                    }))
                })
            ]
        });
    } else if ((mobile === null || mobile === void 0 ? void 0 : mobile.renderAsCard) && isMobileDevice) {
        return /*#__PURE__*/ _jsx(MobileSelect, _object_spread_props(_object_spread({}, restProps), {
            mobile: mobile,
            ref: ref
        }));
    } else {
        // Inside a bottom sheet the default menu popover paints behind the sheet — lift only its
        // z-index (deep-merged so BaseTextField's own MenuProps, incl. the backdrop testId, survive).
        const selectProps = menuAsPopover && isInBottomSheet ? merge({}, restProps.SelectProps, {
            MenuProps: {
                style: {
                    zIndex: zIndexScale.inlinePicker + 1
                }
            }
        }) : restProps.SelectProps;
        return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, restProps), {
            SelectProps: selectProps,
            ref: ref,
            select: true
        }));
    }
});
export const Select = SelectImpl;
